function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28.0027,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.0589 4.45517L9.92028 4L9.31424 4.0059C8.31171 4.0059 7.49609 4.79421 7.49609 5.76316C7.49609 6.73212 8.31171 7.52043 9.31424 7.52043H12.0589V4.45517Z",
  fill: "#0A3C53"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.2592 4.0059L20.6532 4L18.5195 4.48165V7.52043H21.2592C22.2618 7.52043 23.0774 6.73212 23.0774 5.76316C23.0774 4.79421 22.2618 4.0059 21.2592 4.0059Z",
  fill: "#0A3C53"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.8137 8.72632L18.1953 11.6631L19.8571 18.1421V23.9999H24.5009V20.0597L23.3266 17.2606L24.5009 16.4728V13.1246L19.8137 8.72632Z",
  fill: "#FBC8B9"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5767 13.8858L10.7477 12.8879L9.92578 14.7737V18.1422H13.411L14.6756 16.8179L13.5767 13.8858Z",
  fill: "#179E83"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.0663 13.3181L16.0547 15.97L17.1725 18.142H20.6588V14.7735L17.0663 13.3181Z",
  fill: "#179E83"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.98047 20.007L8.1234 20.8354L7.34632 20.0843L7.34632 24L6.74027 24L6.38408 21.2862L6.74028 17.8418L8.98047 20.007Z",
  fill: "#DB51C9"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.73828 17.8418L6.73828 24L6.13223 24L6.13223 20.0843L5.3552 20.8354L4.49813 20.007L6.73828 17.8418Z",
  fill: "#DB51C9"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.92578 4.00024V14.7737C11.8506 14.7737 13.411 16.2818 13.411 18.1422H15.2906L16.6641 9.2943L15.2906 4.00024L9.92578 4.00024Z",
  fill: "#1DD575"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.293 4.00024V18.1422H17.1726C17.1726 16.2818 18.7341 14.7737 20.6589 14.7737V4.00024H15.293Z",
  fill: "#1DD575"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.6758 13.7479H15.2908L15.5983 13.1535L15.2908 12.5591H14.6758V13.7479Z",
  fill: "#179E83"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.293 7.99733C12.293 9.59578 13.6385 10.8962 15.2923 10.8962L16.3714 7.99733L15.2923 5.09839C13.6385 5.09839 12.293 6.39884 12.293 7.99733Z",
  fill: "#179E83"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.2891 5.09839V10.8962C16.9429 10.8962 18.2884 9.59574 18.2884 7.99729C18.2884 6.39884 16.9429 5.09839 15.2891 5.09839Z",
  fill: "#179E83"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.2852 12.5588H15.9002V13.7477H15.2852V12.5588Z",
  fill: "#179E83"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.9909 11.1397C18.4577 10.6243 17.5933 10.6243 17.0601 11.1397C16.5269 11.655 16.5269 12.4906 17.0601 13.0059L19.8076 15.6615V17.8644C19.8076 19.3572 21.0598 20.5674 22.6043 20.5674H24.4928V16.473L18.9909 11.1397Z",
  fill: "#FFDDCE"
});

var SvgNoptienActive = function SvgNoptienActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoptienActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noptien_active.c29bfc59.svg";
export { ForwardRef as ReactComponent };